// extracted by mini-css-extract-plugin
export default {"modalDialog":"OnBoardingModal_modalDialog__L1AHl","modalContent":"OnBoardingModal_modalContent__63RT-","modal":"OnBoardingModal_modal__DPm1i"};